<template>
  <section>
    <section class="full-screen-autoheight flex-center white anchor" :style="{backgroundImage: 'url(/static/img/unmannedstore/1bg.jpg)'}">
      <div class="w50 full-content" style="padding-top: 288px;box-sizing: border-box;">
        <div class="text-right flex-col-center" style="margin-right: 90px;">
          <span class="font100" style="margin-bottom: 16px;line-height: 127px;">无人零售</span>
          <span class="font40 lighter">Unmanned retail</span>
        </div>
      </div>
      <div class="w50 full-content red-mask scroll-animate" data-animate-class="fade-in-right" style="padding-top: 288px;box-sizing: border-box;">
        <article class="text-left flex-col-center font24 normal-lineheight lighter" data-animate-class="fade-in-right-d5" style="margin-left: 28px;">
          <span>零售业态在不到20年的时间内，经历了传统的店铺 </span>
          <span>销售时代、电商时代、O2O时代的快速变革。</span>
          <span>目前阶段社区新零售时代已经开始萌芽，各大行业</span>
          <span>巨头纷纷布局社区阵地，群雄逐鹿，一套完整的无</span>
          <span>人零售解决方案将是制胜法宝。</span>
          <span>果小7新一代���能解决方案，旨在构建云加端的系统</span>
          <span>架构，利用智能识别商品、在线收费系统、智能防</span>
          <span>盗系统等技术，提供前所未有的科技生活体验。</span>
        </article>
      </div>
    </section>
    <section class="full-screen-autoheight flex-center" :style="{backgroundImage: 'url(/static/img/unmannedstore/2bg.jpg)'}">
      <div class="w70 full-content red-mask white scroll-animate" data-animate-class="fade-in-left">
        <div class="full-content" style="margin-left: auto;width: 920px;box-sizing:border-box;padding-right: 90px;">
          <div class="text-center flex-col-center" style="padding-top: 240px;margin-bottom: 155px;">
            <p class="m0 font120" style="margin-bottom: 40px;">供应链</p>
            <span class="font40 lighter">Supply chain</span>
          </div>
          <div class="flex-between">
            <div class="chain-box font24 lighter"
                 v-for="(item,$index) in chains"
                 :key="$index">
              <span>{{item.name}}</span>
              <span>{{item.des}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w30 full-content"></div>
    </section>
    <section class="full-screen-autoheight flex-center" :style="{backgroundImage: 'url(/static/img/unmannedstore/3bg.jpg)'}">
      <div class="w55 full-content white">
        <div style="margin-left: 400px;margin-top: 120px;">
          <table>
            <tr style="display:block;margin-bottom: 90px;"
                v-for="(item,$index) in supplies" :key="$index">
              <td class="font24" style="width: 210px;">{{item[0]}}</td>
              <td class="font18 lighter">{{item[1]}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="w45 full-content red-mask font100 white scroll-animate" data-animate-class="fade-in-right" style="padding-left: 60px;">
        <p class="mt120 m0 lighter" style="margin-top: 120px;">城市供应</p>
        <span class="lighter">网络</span>
        <p class="font40 lighter">Urban supply network</p>
      </div>
    </section>
    <section class="full-screen" :style="{ backgroundImage: 'url(/static/img/unmannedstore/4bg.jpg)' }">
      <div class="w100 h50">
        <section class="m-w flex-center white scroll-animate" data-animate-class="fade-in-up" style="height: 210px;padding-top: 180px;">
          <div class="text-right flex-col-between h100">
            <span class="font100">快速分销系统</span>
            <span class="font40 lighter">Intelligent rapid distribution system</span>
          </div>
          <div class="h100" style="width: 1px;background-color: #707070;margin: 0 30px;"></div>
          <div class="font24 flex-col-between lighter h100">
            <span>依托智能化分销系统，</span>
            <span>支撑数十万种SKU的管理及溯源、</span>
            <span>支撑全国智能化铺货及</span>
            <span>高效运营构建每个场景点的消费画像，</span>
            <span>未来合作伙伴更具有实用性的消费大数据资源</span>
          </div>
        </section>
      </div>
      <div class="w100 h50" style="background-color: RGBA(255, 42, 0, .3);position:relative;">
        <section class="m-w white" >
          <div class="w100 scroll-animate" data-animate-class="fade-in-up" :style="{ position:'absolute',left: '0', right: '0', margin: 'auto', width: '980px' }">
            <div class="border-white flex-col-around text-center" style="width: 457px;height:139px;position:relative; left: 262px;top: 100px;">
              <p class="font48 m0">无人销售平台</p>
              <p class="font24 m0">基于机器学习以及实时数据分析</p>
            </div>
            <div class="border-white border-line" style="left:490px;top:239px;height:69px;width:0;"></div>
            <div class="border-white border-line" style="left:115px;top:310px;width:750px;"></div>
            <div class="border-white border-line" style="left:115px;top:310px;height:60px;"></div>
            <div class="border-white border-line" style="left:365px;top:310px;height:60px;"></div>
            <div class="border-white border-line" style="left:615px;top:310px;height:60px;"></div>
            <div class="border-white border-line" style="left:865px;top:310px;height:60px;"></div>
            <div class="border-white flex-center font24" style="position:absolute;left:0px;top:369px;width:230px;height:69px;">
              机器学习智能铺货
            </div>
            <div class="border-white flex-center font24" style="position:absolute;left:250px;top:369px;width:230px;height:69px;">
              实时销售分析系统
            </div>
            <div class="border-white flex-center font24" style="position:absolute;left:500px;top:369px;width:230px;height:69px;">
              供应链优化体系
            </div>
            <div class="border-white flex-center font24" style="position:absolute;left:750px;top:369px;width:230px;height:69px;">
              智能货架防盗体系
            </div>
          </div>
        </section>
      </div>
    </section>
    <section class="full-screen-autoheight flex-center white" :style="{ backgroundImage: 'url(/static/img/unmannedstore/5bg.jpg)',paddingTop:'200px',boxSizing: 'border-box' }">
      <section class="h100 bg-just text-right" style="width: 46.875%;padding-right: 90px;">
        <div class="flex-col-between font100" style="line-height: 131px;">
          <span>多种消费</span>
          <span>场景复制</span>
        </div>
        <div class="lighter flex-col-between font40" style="line-height: 52px;">
          <span>Replication of</span>
          <span>multiple consumption</span>
          <span>scenarios</span>
        </div>
      </section>
      <section class="h100 text-left" style="width: 53.125%;padding-left: 90px;">
        <div class="font24 flex-col" style="margin-bottom:69px;">
          <span>几禾云的无人零售技术帮助多种方向的合作伙伴切入新</span>
          <span>零售，为用户提供更多样化的场景式消费服务。</span>
        </div>
        <div v-for="(item, $index) in scenes"
             :key="$index"
             style="margin-bottom: 50px;">
          <div class="font24">
            <span class="flex-center bg-red" style="width: 176px;height: 70px;margin-bottom: 15px;">{{item.name}}</span>
          </div>
          <span class="font18">{{item.des}}</span>
        </div>
      </section>
    </section>
    <InnerFooter />
    <Footer />
  </section>
</template>

<script>
  import InnerFooter from '@/components/InnerFooter'
  import VueScroll from '@/api/animateDom'

  import Footer from '@/components/Footer'

  import justHeight from '@/api/justHeight'

  export default {
    components: {InnerFooter, Footer },
    mounted(){
      justHeight.justHeight();

      this.vueScroll = new VueScroll(this, {
        delay: 300
      });
      this.vueScroll.run();
    },
    data(){
      return {
        chains: [
          { name: '城市供应链', des: '网络联盟' },
          { name: '全球30万种', des: '商品精选' },
          { name: '智能配送', des: '系统管理' }
        ],
        supplies:[
          ['产品自营', '支持合作伙伴自营产品售卖'],
          ['品牌供应商', '全国供应网络SKU超过30万种'],
          ['新零售配送', '专业的无人零售配送团队'],
          ['智能云仓储', '支持个性化定制的仓储加工中心'],
          ['管理平台', '软件管理系统，帮助供应链体系高效运行']
        ],
        scenes: [
          { name: '零售企业', des: '上海巨鹿集团等数十家零售管理集团公司' },
          { name: '酒店合作伙伴', des: '住友集团和几禾科技签约，把全国600个布丁酒店大堂改建成无人便利店。' },
          { name: '电商企业', des: '几禾科技联合缔盟网络、耕人电子等电商企业，合作开发新零售业态。' }
        ]
      }
    }
  }
</script>

<style>

  .fade-in-up {
    animation: fadeInUp 1s ease;
  }

  .red-des{
    background-color: #FF2A00;
    padding: 20px 64px 16px 20px;
  }

  .chain-box:nth-child(3){
    margin:0;
  }

  .chain-box span:nth-child(1){
    margin-bottom: 12px;
  }

  .chain-box {
    position: relative;
    box-sizing: border-box;
    border: 1px solid #ffffff;
    width: 188px;
    height: 188px;
    padding: 20px 24px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    font-size: 24px;
  }

  .chain-box:after{
    right: 20px;
    top: 20px;
    content: '+';
    font-weight: lighter;
    position: absolute;
    font-size: 30px;
  }

  .fade-in-left{
    animation: fadeInLeft 1s ease;
  }

  .fade-in-right{
    animation: fadeInRight 1s ease;
  }

  .fade-in-right-d5{
    animation: fadeInRight 2s ease;
  }

  .border-line{
    position: absolute;
    border-width:.5px;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/pages/UnmannedStore/index.vue